/**
 *
 * @export
 * @interface WorkspaceServiceAccessDeniedErrorResponseDto
 */
export interface WorkspaceServiceAccessDeniedErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAccessDeniedErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAccessDeniedErrorResponseDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAccessDeniedErrorResponseDto
   */
  reason?: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceAccessDto
 */
export interface WorkspaceServiceAccessDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAccessDto
   */
  type: WorkspaceServiceAccessDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAccessDto
   */
  role: string;
  /**
   *
   * @type {Array<string>}
   * @memberof WorkspaceServiceAccessDto
   */
  privileges: Array<string>;
  /**
   * Whether privileges are reduced due to suspension of the business org
   * @type {boolean}
   * @memberof WorkspaceServiceAccessDto
   */
  reduced?: boolean;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAccessDto
   */
  orgId?: string;
}

export const WorkspaceServiceAccessDtoTypeEnum = {
  Org: 'org',
  Member: 'member',
} as const;

export type WorkspaceServiceAccessDtoTypeEnum =
  (typeof WorkspaceServiceAccessDtoTypeEnum)[keyof typeof WorkspaceServiceAccessDtoTypeEnum];

/**
 *
 * @export
 * @interface WorkspaceServiceAddMemberRequestDto
 */
export interface WorkspaceServiceAddMemberRequestDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAddMemberRequestDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAddMemberRequestDto
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAddMemberRequestDto
   */
  role: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAddMemberRequestDto
   */
  encryptRole?: string;
  /**
   * Role for the user to set in the org if the user is not in the org yet, only for business
   * @type {string}
   * @memberof WorkspaceServiceAddMemberRequestDto
   */
  orgRole?: string;
  /**
   * TTL of the org member in seconds, only for bussiness orgs
   * @type {number}
   * @memberof WorkspaceServiceAddMemberRequestDto
   */
  memberTTL?: number;
  /**
   *
   * @type {Array<WorkspaceServicePermissionItemDto>}
   * @memberof WorkspaceServiceAddMemberRequestDto
   */
  permissions?: Array<WorkspaceServicePermissionItemDto>;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAddMemberRequestDto
   */
  portalUrl?: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceAddMemberResponseDto
 */
export interface WorkspaceServiceAddMemberResponseDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAddMemberResponseDto
   */
  result: WorkspaceServiceAddMemberResponseDtoResultEnum;
  /**
   *
   * @type {WorkspaceServiceMemberDto}
   * @memberof WorkspaceServiceAddMemberResponseDto
   */
  member?: WorkspaceServiceMemberDto;
  /**
   *
   * @type {WorkspaceServiceInviteDto}
   * @memberof WorkspaceServiceAddMemberResponseDto
   */
  invite?: WorkspaceServiceInviteDto;
  /**
   *
   * @type {WorkspaceServiceMagicLinkDto}
   * @memberof WorkspaceServiceAddMemberResponseDto
   */
  magicLink?: WorkspaceServiceMagicLinkDto;
}

export const WorkspaceServiceAddMemberResponseDtoResultEnum = {
  Member: 'member',
  Invite: 'invite',
  Link: 'link',
} as const;

export type WorkspaceServiceAddMemberResponseDtoResultEnum =
  (typeof WorkspaceServiceAddMemberResponseDtoResultEnum)[keyof typeof WorkspaceServiceAddMemberResponseDtoResultEnum];

/**
 *
 * @export
 * @interface WorkspaceServiceAvatarDto
 */
export interface WorkspaceServiceAvatarDto {
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceAvatarDto
   */
  userId?: number;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAvatarDto
   */
  workspaceId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceAvatarDto
   */
  storedFileUUID?: string;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceAvatarDto
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceAvatarDto
   */
  updatedAt?: number;
}
/**
 *
 * @export
 * @interface WorkspaceServiceBrandingProfileCreateUpdateParamsDto
 */
export interface WorkspaceServiceBrandingProfileCreateUpdateParamsDto {
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileCreateUpdateParamsDto
   */
  sharesAllowIndexing?: boolean;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceBrandingProfileCreateUpdateParamsDto
   */
  sharesLogoPosition?: string;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileCreateUpdateParamsDto
   */
  sharesTopbar?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileCreateUpdateParamsDto
   */
  sharesFullscreen?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileCreateUpdateParamsDto
   */
  sharesShareButton?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileCreateUpdateParamsDto
   */
  sharesShowDate?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileCreateUpdateParamsDto
   */
  sharesCopyBlotLinkIcon?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileCreateUpdateParamsDto
   */
  sharesOutliner?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileCreateUpdateParamsDto
   */
  sharesAllowPrint?: boolean;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceBrandingProfileCreateUpdateParamsDto
   */
  theme?: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceBrandingProfileDto
 */
export interface WorkspaceServiceBrandingProfileDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  globalId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  orgId?: string;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  updatedAt?: number;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  sharesAllowIndexing?: boolean;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  sharesLogoPosition?: string;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  sharesTopbar?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  sharesFullscreen?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  sharesShareButton?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  sharesShowDate?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  sharesCopyBlotLinkIcon?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  sharesOutliner?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  sharesAllowPrint?: boolean;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceBrandingProfileDto
   */
  theme?: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceChangeWorkspaceOrgDataDto
 */
export interface WorkspaceServiceChangeWorkspaceOrgDataDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceChangeWorkspaceOrgDataDto
   */
  orgId: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceCountInvitesDto
 */
export interface WorkspaceServiceCountInvitesDto {
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceCountInvitesDto
   */
  count: number;
}
/**
 *
 * @export
 * @interface WorkspaceServiceCountMembersDto
 */
export interface WorkspaceServiceCountMembersDto {
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceCountMembersDto
   */
  count: number;
}
/**
 *
 * @export
 * @interface WorkspaceServiceCountWorkspacesDto
 */
export interface WorkspaceServiceCountWorkspacesDto {
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceCountWorkspacesDto
   */
  count: number;
}
/**
 *
 * @export
 * @interface WorkspaceServiceCreateWorkspaceDataDto
 */
export interface WorkspaceServiceCreateWorkspaceDataDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceCreateWorkspaceDataDto
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceCreateWorkspaceDataDto
   */
  title: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceEncryptionKeyCreateObjectDto
 */
export interface WorkspaceServiceEncryptionKeyCreateObjectDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceEncryptionKeyCreateObjectDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceEncryptionKeyCreateObjectDto
   */
  publicKey: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceEncryptionKeyCreateObjectDto
   */
  privateKey: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceEncryptionKeyDto
 */
export interface WorkspaceServiceEncryptionKeyDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceEncryptionKeyDto
   */
  uuid: string;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceEncryptionKeyDto
   */
  dateAdded: number;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceEncryptionKeyDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceEncryptionKeyDto
   */
  publicKey: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceEncryptionKeyDto
   */
  privateKey: string;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceEncryptionKeyDto
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceEncryptionKeyDto
   */
  workspaceId: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceErrorResponseDto
 */
export interface WorkspaceServiceErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceErrorResponseDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceEventDto
 */
export interface WorkspaceServiceEventDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceEventDto
   */
  reason?: string;
  /**
   * event name
   * @type {string}
   * @memberof WorkspaceServiceEventDto
   */
  name?: string;
  /**
   * event payload
   * @type {object}
   * @memberof WorkspaceServiceEventDto
   */
  payload?: object;
}
/**
 *
 * @export
 * @interface WorkspaceServiceHtmlDataDto
 */
export interface WorkspaceServiceHtmlDataDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceHtmlDataDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceHtmlDataDto
   */
  htmlHead?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceHtmlDataDto
   */
  htmlBody?: string;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceHtmlDataDto
   */
  showWebClient?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceHtmlDataDto
   */
  showPublicLinks?: boolean;
  /**
   * Only top/center/bottom are allowed
   * @type {string}
   * @memberof WorkspaceServiceHtmlDataDto
   */
  bodyPosition?: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceHtmlDto
 */
export interface WorkspaceServiceHtmlDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceHtmlDto
   */
  globalId?: string;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceHtmlDto
   */
  userId?: number;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceHtmlDto
   */
  workspaceId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceHtmlDto
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceHtmlDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceHtmlDto
   */
  htmlHead?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceHtmlDto
   */
  htmlBody?: string;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceHtmlDto
   */
  showWebClient?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceHtmlDto
   */
  showPublicLinks?: boolean;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceHtmlDto
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceHtmlDto
   */
  updatedAt?: number;
  /**
   * Only top/center/bottom are allowed
   * @type {string}
   * @memberof WorkspaceServiceHtmlDto
   */
  bodyPosition?: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceInternalErrorResponseDto
 */
export interface WorkspaceServiceInternalErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceInternalErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceInternalErrorResponseDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceInviteDto
 */
export interface WorkspaceServiceInviteDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceInviteDto
   */
  workspaceId: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceInviteDto
   */
  role: string;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceInviteDto
   */
  addedByUserId: number;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceInviteDto
   */
  email: string;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceInviteDto
   */
  createdAt: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceInviteDto
   */
  updatedAt: number;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceInviteDto
   */
  used: boolean;
  /**
   *
   * @type {Array<WorkspaceServicePermissionItemDto>}
   * @memberof WorkspaceServiceInviteDto
   */
  permissions?: Array<WorkspaceServicePermissionItemDto>;
}
/**
 *
 * @export
 * @interface WorkspaceServiceInviteRequestDto
 */
export interface WorkspaceServiceInviteRequestDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceInviteRequestDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceInviteRequestDto
   */
  role: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceInviteRequestDto
   */
  workspaceId: string;
  /**
   *
   * @type {Array<WorkspaceServicePermissionItemDto>}
   * @memberof WorkspaceServiceInviteRequestDto
   */
  permissions?: Array<WorkspaceServicePermissionItemDto>;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceInviteRequestDto
   */
  portalUrl?: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceMagicLinkDto
 */
export interface WorkspaceServiceMagicLinkDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceMagicLinkDto
   */
  type: WorkspaceServiceMagicLinkDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceMagicLinkDto
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceMagicLinkDto
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceMagicLinkDto
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceMagicLinkDto
   */
  workspaceId: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceMagicLinkDto
   */
  url: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceMagicLinkDto
   */
  magicLink: string;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceMagicLinkDto
   */
  createdAt: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceMagicLinkDto
   */
  updatedAt: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceMagicLinkDto
   */
  deletedAt?: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceMagicLinkDto
   */
  expiresAt?: number;
}

export const WorkspaceServiceMagicLinkDtoTypeEnum = {
  Portal: 'portal',
} as const;

export type WorkspaceServiceMagicLinkDtoTypeEnum =
  (typeof WorkspaceServiceMagicLinkDtoTypeEnum)[keyof typeof WorkspaceServiceMagicLinkDtoTypeEnum];

/**
 *
 * @export
 * @interface WorkspaceServiceMemberDto
 */
export interface WorkspaceServiceMemberDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceMemberDto
   */
  globalId: string;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceMemberDto
   */
  addedByUserId: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceMemberDto
   */
  userId: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceMemberDto
   */
  createdAt: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceMemberDto
   */
  updatedAt: number;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceMemberDto
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceMemberDto
   */
  workspaceId: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceMemberDto
   */
  role: string;
  /**
   *
   * @type {Array<string>}
   * @memberof WorkspaceServiceMemberDto
   */
  privileges: Array<string>;
}
/**
 *
 * @export
 * @interface WorkspaceServiceNotFoundErrorResponseDto
 */
export interface WorkspaceServiceNotFoundErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceNotFoundErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceNotFoundErrorResponseDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface WorkspaceServicePermissionItemDto
 */
export interface WorkspaceServicePermissionItemDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServicePermissionItemDto
   */
  noteId: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServicePermissionItemDto
   */
  role: WorkspaceServicePermissionItemDtoRoleEnum;
}

export const WorkspaceServicePermissionItemDtoRoleEnum = {
  Reader: 'reader',
  Editor: 'editor',
  Denied: 'denied',
} as const;

export type WorkspaceServicePermissionItemDtoRoleEnum =
  (typeof WorkspaceServicePermissionItemDtoRoleEnum)[keyof typeof WorkspaceServicePermissionItemDtoRoleEnum];

/**
 *
 * @export
 * @interface WorkspaceServiceSetDefaultEncryptionKeyRequestDto
 */
export interface WorkspaceServiceSetDefaultEncryptionKeyRequestDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceSetDefaultEncryptionKeyRequestDto
   */
  uuid: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceTouchDto
 */
export interface WorkspaceServiceTouchDto {
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceTouchDto
   */
  updatedAt?: number;
}
/**
 *
 * @export
 * @interface WorkspaceServiceUpdateAvatarDataDto
 */
export interface WorkspaceServiceUpdateAvatarDataDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceUpdateAvatarDataDto
   */
  tempFileName?: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceUpdateInviteDataDto
 */
export interface WorkspaceServiceUpdateInviteDataDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceUpdateInviteDataDto
   */
  role?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceUpdateInviteDataDto
   */
  encryptRole?: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceUpdateMemberRequestDto
 */
export interface WorkspaceServiceUpdateMemberRequestDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceUpdateMemberRequestDto
   */
  role?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceUpdateMemberRequestDto
   */
  encryptRole?: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceUpdateWorkspaceDataDto
 */
export interface WorkspaceServiceUpdateWorkspaceDataDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceUpdateWorkspaceDataDto
   */
  title?: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceUsageDto
 */
export interface WorkspaceServiceUsageDto {
  /**
   *
   * @type {WorkspaceServiceUsageItemDto}
   * @memberof WorkspaceServiceUsageDto
   */
  traffic?: WorkspaceServiceUsageItemDto;
  /**
   *
   * @type {WorkspaceServiceUsageItemDto}
   * @memberof WorkspaceServiceUsageDto
   */
  encryptionKeys?: WorkspaceServiceUsageItemDto;
  /**
   *
   * @type {WorkspaceServiceUsageItemDto}
   * @memberof WorkspaceServiceUsageDto
   */
  members?: WorkspaceServiceUsageItemDto;
}
/**
 *
 * @export
 * @interface WorkspaceServiceUsageItemDto
 */
export interface WorkspaceServiceUsageItemDto {
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceUsageItemDto
   */
  current: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceUsageItemDto
   */
  max: number;
}
/**
 *
 * @export
 * @interface WorkspaceServiceValidationErrorResponseDto
 */
export interface WorkspaceServiceValidationErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceValidationErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceValidationErrorResponseDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceValidationErrorResponseDto
   */
  field: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceWebClientBrandingCustomQuickLinkDto
 */
export interface WorkspaceServiceWebClientBrandingCustomQuickLinkDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceWebClientBrandingCustomQuickLinkDto
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceWebClientBrandingCustomQuickLinkDto
   */
  title?: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceWebClientBrandingProfileCreateUpdateParamsDto
 */
export interface WorkspaceServiceWebClientBrandingProfileCreateUpdateParamsDto {
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceWebClientBrandingProfileCreateUpdateParamsDto
   */
  templatesButton?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceWebClientBrandingProfileCreateUpdateParamsDto
   */
  hideNimbusMentionsInSettings?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof WorkspaceServiceWebClientBrandingProfileCreateUpdateParamsDto
   */
  quickLinks?: Array<string>;
  /**
   *
   * @type {Array<WorkspaceServiceWebClientBrandingCustomQuickLinkDto>}
   * @memberof WorkspaceServiceWebClientBrandingProfileCreateUpdateParamsDto
   */
  quickLinksCustom?: Array<WorkspaceServiceWebClientBrandingCustomQuickLinkDto>;
  /**
   *
   * @type {Array<string>}
   * @memberof WorkspaceServiceWebClientBrandingProfileCreateUpdateParamsDto
   */
  bottomMenu?: Array<string>;
}
/**
 *
 * @export
 * @interface WorkspaceServiceWebClientBrandingProfileDto
 */
export interface WorkspaceServiceWebClientBrandingProfileDto {
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceWebClientBrandingProfileDto
   */
  templatesButton?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceWebClientBrandingProfileDto
   */
  hideNimbusMentionsInSettings?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof WorkspaceServiceWebClientBrandingProfileDto
   */
  quickLinks?: Array<string>;
  /**
   *
   * @type {Array<WorkspaceServiceWebClientBrandingCustomQuickLinkDto>}
   * @memberof WorkspaceServiceWebClientBrandingProfileDto
   */
  quickLinksCustom?: Array<WorkspaceServiceWebClientBrandingCustomQuickLinkDto>;
  /**
   *
   * @type {Array<string>}
   * @memberof WorkspaceServiceWebClientBrandingProfileDto
   */
  bottomMenu?: Array<string>;
}
/**
 *
 * @export
 * @interface WorkspaceServiceWorkspaceAccessItemDto
 */
export interface WorkspaceServiceWorkspaceAccessItemDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceWorkspaceAccessItemDto
   */
  workspaceId: string;
  /**
   *
   * @type {WorkspaceServiceAccessDto}
   * @memberof WorkspaceServiceWorkspaceAccessItemDto
   */
  access: WorkspaceServiceAccessDto;
}
/**
 *
 * @export
 * @interface WorkspaceServiceWorkspaceDto
 */
export interface WorkspaceServiceWorkspaceDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceWorkspaceDto
   */
  globalId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceWorkspaceDto
   */
  orgId?: string;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceWorkspaceDto
   */
  userId?: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceWorkspaceDto
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceWorkspaceDto
   */
  updatedAt?: number;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceWorkspaceDto
   */
  title?: string;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceWorkspaceDto
   */
  isDefault?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceWorkspaceDto
   */
  isNotesLimited?: boolean;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceWorkspaceDto
   */
  color?: string;
  /**
   * subscriptionType from org-service /orgs/{org}/info
   * @type {string}
   * @memberof WorkspaceServiceWorkspaceDto
   */
  orgSubscriptionType?: string;
  /**
   * subscriptionPrivileges from org-service /orgs/{org}/info
   * @type {Array<string>}
   * @memberof WorkspaceServiceWorkspaceDto
   */
  orgSubscriptionPrivileges?: Array<string>;
}
/**
 *
 * @export
 * @interface WorkspaceServiceWorkspaceExtraDto
 */
export interface WorkspaceServiceWorkspaceExtraDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceWorkspaceExtraDto
   */
  globalId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceWorkspaceExtraDto
   */
  orgId?: string;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceWorkspaceExtraDto
   */
  userId?: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceWorkspaceExtraDto
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof WorkspaceServiceWorkspaceExtraDto
   */
  updatedAt?: number;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceWorkspaceExtraDto
   */
  title?: string;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceWorkspaceExtraDto
   */
  isDefault?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WorkspaceServiceWorkspaceExtraDto
   */
  isNotesLimited?: boolean;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceWorkspaceExtraDto
   */
  color?: string;
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceWorkspaceExtraDto
   */
  avatarStoredFileUUID?: string;
}
/**
 *
 * @export
 * @interface WorkspaceServiceWorkspaceItemDto
 */
export interface WorkspaceServiceWorkspaceItemDto {
  /**
   *
   * @type {string}
   * @memberof WorkspaceServiceWorkspaceItemDto
   */
  workspaceId: string;
}
